import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/Layout.vue'),
    children: [
      // { path: 'RiveAnimation', name: 'RiveAnimation', component: () => import('@/views/RiveAnimation.vue') },
      { path: '', name: 'myList', component: () => import('@/views/myList.vue') },
      { path: 'class_management', name: 'class_management', component: () => import('@/views/ClassManagement.vue') },
      { path: 'student/list/:group_id?/:user_id?/:book_id?/:record_index?', name: 'student_list', component: () => import('@/views/StudentList.vue') },
      { path: 'ai_learning', name: 'learning_portal', component: () => import('@/views/learning_portal.vue') },
      // { path: '/class_usage_records', name: 'class_usage_records', component: () => import('@/views/class_usage_records.vue') },
      // { path: '/class_usage_records/:bookId', name: 'class_usage_records_item', component: () => import('@/views/class_usage_records_item.vue') },

      { path: '/books/:bookId?', name: 'books', component: () => import('@/views/bookList.vue') },

      // { path: 'AI/intro/:lang?', name: 'intro', component: () => import('@/views/Generate/Intro.vue') },
      { path: 'AI/:bookId?/:promptId?/:item_id?', name: 'ChatAI', component: () => import('@/views/Chat.vue') },
      { path: 'AI/:bookId?/jp/:promptId?/:item_id?', name: 'ChatAIJp', component: () => import('@/views/Chat.vue') },
      { path: 'AI/:bookId?/fr/:promptId?/:item_id?', name: 'ChatAIFr', component: () => import('@/views/Chat.vue') },

      { path: 'view/:lang', name: 'viewChat', component: () => import('@/views/Chat.vue') },
      // { path: 'AI/generate/:aiType?', name: 'SpeechAI', component: () => import('@/views/Generate/Speech.vue'), meta: { requiresAuth: true, gtm: 'SpeechAI' } },
      // { path: 'AI/generate/jp/:aiType?', name: 'SpeechAIJp', component: () => import('@/views/Generate/Speech.vue'), meta: { requiresAuth: true, gtm: 'SpeechAIJp' } },

      // { path: '/writing/:promptId?', name: 'Writing', component: () => import('@/views/Writing.vue') }
      { path: 'GEPT/f/:select_id/:practice_type?', name: 'formal_exam', component: () => import('@/views/GEPT/Practice.vue') },
      { path: 'GEPT/report_formal_exam/:record_id', name: 'gept_report_formal', component: () => import('@/views/GEPT/Report.vue') },
      { path: 'GEPT/report/:select_id/:record_id', name: 'gept_report_part', component: () => import('@/views/GEPT/Report.vue') },

      { path: 'composition/report/:select_id/:id', name: 'Composition_report', component: () => import('@/views/composition/Report2.vue') },
      { path: 'report/:group_id/:user_id/:book_id/:record_id', name: 'Report2', component: () => import('@/views/composition/Report2.vue') },
      // { path: 'composition/report2/:select_id/:id', name: 'Composition_report2', component: () => import('@/views/composition/Report2.vue') },

      { path: 'composition/:select_id/:id', name: 'Composition', component: () => import('@/views/composition/Composition.vue') }
    ]
  },
  // { path: '/google_login', name: 'google_login', component: () => import('@/views/testGoogle.vue') },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
  },
  {
    path: '/prime-english',
    name: 'login_prime_english',
    component: () => import('@/views/Login.vue'),
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/Register.vue'),
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  }
})

export default router
